<div class="container">
  <div class="flex items-center justify-between">
    <h5 class="title-header">Sites</h5>
    <button mat-flat-button color="primary" #button (click)="openSiteModal(button)">
      @if (!loader) {
        Manage Sites
      } @else {
        <mat-spinner diameter="20"></mat-spinner>
      }
    </button>
  </div>
</div>
<ul class="sites-list list-group list-group-flush" *ngIf="programSites?.length > 0">
  <li class="list-group-item" *ngFor="let programSite of programSites">{{programSite.name}}</li>
</ul>
<span *ngIf="programSites?.length === 0" class="font-weight-bold text-center">No Sites Configured.</span>
<br /><br />
